/**
 * Bootstrapping file
 *
 * For perfomance optimization, Page View tracking and Video module Start tracking 
 * needs to trigger ASAP.
 *
 *      - Implement Dynamic Imports
 *      - Page View trackig happens on window's load event
 *      - Loading / Importing any files before the load event may block window's load event.
 *      - Load other modules below the Main Section after page load is complete
 */

let interDisciplinaryCase = window.interDisciplinaryCase || {};
// Define the version here to help debug a program's release version.
// VERSION and DATE_STRING are global module constants defined in Webpack's config.
// DO NOT import 'package.json' to get the version.
interDisciplinaryCase.version = VERSION;
interDisciplinaryCase.BUILD_DATE = DATE_STRING;
const { Promise } = window;

function handlePageLoad() {
    import('./lazy-load-modules').then(module => {
        const { default: LazyLoadModule } = module;
        LazyLoadModule.init();
    });


    // Preload the Streaming Video Player
    import('@medscape-promo/streaming-video-player').then(module => {
        //console.log("[MTV] SVP Loaded\n",module)
    })
}

const ReactPromise = import("react");
const ReactDomPromise = import("react-dom");
const PostMessagesPromise = import('./post-messages');
Promise.all([ReactPromise, ReactDomPromise, PostMessagesPromise]).then(modules => {
    const React = modules[0];
    const ReactDOM = modules[1];
    const PostMessages = modules[2];
    const { store: pmStore, PostMessagesActions } = PostMessages;
    pmStore.dispatch(PostMessagesActions.init());
    let mainEl = document.getElementById("interdisciplinarycase-app");
    //console.log("[interDisciplinaryCase] Loaded:", interDisciplinaryCase);

    if (mainEl != null) {
        import('./main/main.component').then(module => {
            const { default: Main } = module;
            const onReady = (store => {
                //console.log("[interDisciplinaryCase] Main Module Ready: ", store);
                window.interDisciplinaryCase.stores = {
                    Main: store,
                    PostMessages: pmStore
                };
                if (document.readyState !== 'complete') {
                    window.addEventListener('load', (event) => {
                        handlePageLoad();
                    });
                } else {
                    handlePageLoad();
                }
                mainEl.classList.add('ready');
            })
            const { series, episodes, tracking, ifi } = interDisciplinaryCase;
            const { Medscape: medscape } = window;
            const props = {
                medscape,
                tracking,
                series,
                episodes,
                onReady,
                ifiPath: ifi != null && ifi.path != null ? ifi.path : "/ifi-1"
            }
            ReactDOM.render(React.createElement(Main, props), mainEl);

        });
    }

});

//console.log("[MTV] document.readyState:", document.readyState);